import React, { useState, useEffect, useContext } from "react";
import { auth } from "./../firebase/firebaseConfig";

const AuthContext = React.createContext();

//Hook para acceder a contexto
const useAuth = () => {
  return useContext(AuthContext);
};

const AuthProvider = ({ children }) => {
  const [usuario, cambiarUsuario] = useState();
  // Creamos un state para saber cuando termina de
  // cargar la comprobacion de onAuthStateChanged
  const [cargando, cambiarCargando] = useState(true);

  useEffect(() => {
    //comprobamos si hay un usuario
    const cancelarSuscripcion = auth.onAuthStateChanged((usuario) => {
      //console.log(usuario);
      cambiarUsuario(usuario);
      cambiarCargando(false);
    });
    return cancelarSuscripcion;
  });

  return (
    <AuthContext.Provider value={{ usuario: usuario }}>
      {/* Solamente retornamos los elementos hijos cuando no este cargando. 
	    De esta forma nos aseguramos de no cargar el resto de la app hasta que el usuario haya sido establecido.
		Si no hacemos esto al refrescar la pagina el componente children intenta cargar inmediatamente, 
		antes de haber comprobado que existe un usuario. */}
      {!cargando && children}
    </AuthContext.Provider>
  );
};

export { AuthProvider, AuthContext, useAuth };
